import styled from 'styled-components';
import { colors, layout, media } from '@prisjakt/ui-base';
import MegaphoneIcon from 'mdi-react/MegaphoneIcon';

export const MegaphoneIconDesktop = styled(MegaphoneIcon).attrs({ size: 24 })`
  ${media.mediumDown`
    display: none;
  `}
`;
export const MegaphoneIconMobile = styled(MegaphoneIcon).attrs({ size: 48 })`
  ${media.largeUp`
    display: none;
  `}
`;

export const PeakIndex = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  font-size: ${layout.fontSizes.small.desktop.rem};
  ${media.mediumDown`
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    text-align: left;
    font-size: ${layout.fontSizes.small.mobile.rem};
    background-color: ${colors.semiWhite};
    border-radius: 8px;
    max-width: 640px;
  `}
`;

export const Icon = styled.div`
  ${media.mediumDown`
    display: flex;
    align-items: center;
    justify-content: center;
  `}
  min-width: 75px;
  ${media.smallOnly`
    min-width: 50px;
    svg {
      max-width: 32px;
    }
  `}
`;
export const Description = styled.div`
  margin-bottom: 8px;
  ${media.mediumDown`
    display: flex;
    align-items: center;
    margin: 8px 0;
  `}
`;
export const PriceChange = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${layout.fontSizes.h2.desktop.rem};
  font-weight: bold;
  background-color: ${colors.semiWhite};
  border-radius: 8px;
  padding: 1rem;
  svg {
    margin-right: 4px;
  }
  ${media.smallOnly`
    font-size: ${layout.fontSizes.base.mobile.rem};
    svg {
      min-width: 24px;
    }
  `}
`;
